import { render } from "./InviteFriend.vue?vue&type=template&id=ff34e7d8&scoped=true&ts=true"
import script from "./InviteFriend.vue?vue&type=script&setup=true&lang=ts"
export * from "./InviteFriend.vue?vue&type=script&setup=true&lang=ts"

import "./InviteFriend.vue?vue&type=style&index=0&id=ff34e7d8&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff34e7d8"],['__file',"src/views/me/InviteFriend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ff34e7d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ff34e7d8', __exports__)) {
    console.log('reload')
    api.reload('ff34e7d8', __exports__)
  }
  
  module.hot.accept("./InviteFriend.vue?vue&type=template&id=ff34e7d8&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('ff34e7d8', render)
  })

}


export default __exports__